// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"carousel_carouselWrapper__rd8Ib","bringgCarousel":"carousel_bringgCarousel__r9zDD","customDotPosition":"carousel_customDotPosition__N8Vk7"};